<template>
  <control-base
    :config="conf"
    :dataType="dataType"
    :parentName="$options.name"
    @state-selected="addState"
    @state-removed="removeState"
    @loaded="$emit('loaded', $event)"
    filterPosition="relative"
    ref="base"
  >
    <template v-slot:filters>
      <div class="flex-full">
        <p>Show Robots:</p>
        <input type="checkbox" v-model="conf.showRobots" />
      </div>
      <div style="border: 1px solid gray; padding: 5px; margin-top: 5px">
        <p>State Colours</p>
        <div
          class="flex-full"
          v-for="state in conf.stateColours"
          :key="state.state"
        >
          <p class="vertical-center">
            {{ getStateTextByValue(state.state) }}
          </p>
          <colour-picker :color="state.color" v-model="state.color" />
        </div>
      </div>
    </template>
    <template v-slot:control>
      <div
        :style="{
          height: locked ? 'calc(100% - 5px)' : 'calc(100% - 25px)',
        }"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <pie-chart
          style="position: relative; height: 100%; width: 100%"
          :chart-data="agentTotals"
        ></pie-chart>
      </div>
    </template>
  </control-base>
</template>

<script>
import { PieChart } from "@/components";

export default {
  name: "AgentStateChart",

  props: {
    config: {
      required: true,
      value: Object,
    },
  },

  components: {
    PieChart,
  },

  data() {
    return {
      dataType: "agent",
    };
  },

  computed: {
    locked() {
      return this.$store.getters.locked;
    },

    conf() {
      return this.config;
    },

    layoutLocked() {
      return this.$store.getters.locked;
    },

    agentTotals() {
      let agents = this.$store.getters.agentData.filter(
        (x) =>
          this.conf.campaignNames.includes(x.campaign) &&
          (this.conf.showRobots ? true : !x.agentName.startsWith("Robot")) &&
          (this.conf.showGDMSMonitor ? true : !x.agentName.startsWith("gdmsmonitor"))
      );

      return {
        labels: this.conf.stateColours.map((x) =>
          this.getStateTextByValue(x.state)
        ),
        datasets: [
          {
            label: "Data One",
            backgroundColor: this.conf.stateColours.map((x) => x.color),
            data: this.conf.stateColours.map(
              (x) => agents.filter((z) => z.agentStateNum == x.state).length
            ),
          },
        ],
      };
    },
  },

  methods: {
    getStateTextByValue(val) {
      return this.$constants.AgentStates.find((x) => x.value == val).name;
    },

    addState(state) {
      this.conf.stateColours.push({
        state: state,
        color: `#${this.generateRandomColor()}`,
      });
      this.$emit("configChange", this.conf);
    },
    generateRandomColor() {
      return Math.floor(Math.random() * 16777215).toString(16);
    },
    removeState(state) {
      var index = this.conf.stateColours.findIndex((x) => x.state == state);
      this.conf.stateColours.splice(index, 1);
      this.$emit("configChange", this.conf);
    },
  },
};
</script>

<style scoped>
.flex-full {
  display: flex;
  width: 100%;
  min-width: 400px;
  justify-content: space-between;
  margin: 5px 0;
}

.vertical-center {
  display: flex;
  align-items: center;
}
</style>